const DIGIOH_INTENT_STORAGE_KEY = 'withDigiohIntent'
const DIGIOH_INTENT_TTL_MS = 60 * 60 * 1000

export default {
    mounted() {
        const withDigiohIntent = this.resolveWithDigiohIntent()

        if (this.$ldClient && this.$ldClient.client) {
            this.$ldClient.client.waitUntilReady().then(() => {
                if (withDigiohIntent) {
                    const digiohIntentContext = {
                        kind: 'digioh_intent',
                        key: 'digioh-intent',
                        withDigiohIntent: true,
                    }

                    this.$ldClient.identifyWithContexts(
                        {
                            digioh_intent: digiohIntentContext,
                        },
                        () => {
                            if (this.$ldClient.getFeatureFlag('CRO_1202_HIDE_EXIT_DIGIOH_INTENT', false)) {
                                document.body.classList.add('ld-hide-lightbox')
                                document.documentElement.classList.add('ld-hide-lightbox')
                                if (this.$ldClient.isInExperiment('CRO_1202_HIDE_EXIT_DIGIOH_INTENT')) {  
                                    this.updateUrlForDigiohExperiment();
                                }
                            }
                        }
                    )
                }
            })
        }
    },
    methods: {
        resolveWithDigiohIntent() {
            if (!window.location) {
                return false
            }

            const value = this.getDigiohIntentValueFromUrl()
            const storedValue = this.getStoredDigiohIntent()
            const now = Date.now()

            if (storedValue && now - storedValue.timestamp <= DIGIOH_INTENT_TTL_MS) {
                return storedValue.value
            }

            this.clearStoredDigiohIntent()
            this.setStoredDigiohIntent(value, now)

            return value
        },

        getDigiohIntentValueFromUrl() {
            const searchParams = new URLSearchParams(window.location.search)
            return (searchParams.get('utm_medium') || '').toLowerCase() !== 'email'
        },

        getStoredDigiohIntent() {
            try {
                const rawValue = window.localStorage.getItem(DIGIOH_INTENT_STORAGE_KEY)

                if (!rawValue) {
                    return null
                }

                const parsedValue = JSON.parse(rawValue)

                if ((Object.hasOwn(parsedValue, 'value') && typeof parsedValue.value !== 'boolean') || (Object.hasOwn(parsedValue, 'timestamp') && typeof parsedValue.timestamp !== 'number')) {
                    return null
                }

                return parsedValue
            } catch {
                return null
            }
        },

        setStoredDigiohIntent(value, timestamp = Date.now()) {
            try {
                window.localStorage.setItem(
                    DIGIOH_INTENT_STORAGE_KEY,
                    JSON.stringify({
                        value,
                        timestamp,
                    })
                )
            } catch {
                // no-op
            }
        },

        clearStoredDigiohIntent() {
            try {
                window.localStorage.removeItem(DIGIOH_INTENT_STORAGE_KEY)
            } catch {
                // no-op
            }
        },

        updateUrlForDigiohExperiment() {
            const searchParams = new URLSearchParams(window.location.search)
            if (searchParams.has('test')) {
                return
            }
            const symbol = window.location.href.includes('?') ? '&' : '?'
            history.replaceState(null, '', window.location.href + symbol + 'test=cro-1202')
        },
    },
}